import moment from 'moment/moment'
import 'moment/locale/ja'

moment.locale('ja')

export default moment
